import { Grid, TextField } from "@mui/material";
import React, { ChangeEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initGroupNameEnAction, initGroupNameTcAction } from "../../redux/BinGroup/action";
import { IRootState } from "../../redux/store";
import { AddBinFormInterface } from "../../redux/BinGroup/state";



function AddBinGroupForm() {
  const dispatch = useDispatch();
      const { newBinGroup } = useSelector(
          (state: IRootState) => state.binGroupListState
      );
  function handleChangeForm(
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: AddBinFormInterface,
  ) {
    switch (field) {
      case "group_name_tc":
        dispatch(initGroupNameTcAction(e.target.value));
        break;
    
        case "group_name_en":
        dispatch(initGroupNameEnAction(e.target.value))

  
        break;
    }
  }

  return (
    <Grid >
      <Grid style={{ display: "flex", flexDirection: "row", gap: 30 }}>
        <Grid style={{ flex: 1 }}>
          <TextField
            id="outlined-required"
            placeholder="請輸入廁所組合名稱"
            value={newBinGroup.group_name_tc}
            fullWidth
            label="廁所名稱(中文)"
            required
            onChange={(e) => handleChangeForm(e, "group_name_tc")}
          />
        </Grid>
        <Grid style={{ flex: 1 }}>
          <TextField
            id="outlined-required"
            placeholder="請輸入廁所組合名稱"
            value={newBinGroup.group_name_en}
            fullWidth
            label="廁所名稱(英文)"
            onChange={(e) => handleChangeForm(e, "group_name_en")}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default AddBinGroupForm;
